/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionControllerRunJob200Response
 */
export interface SubscriptionControllerRunJob200Response {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionControllerRunJob200Response
     */
    result?: string;
}

/**
 * Check if a given object implements the SubscriptionControllerRunJob200Response interface.
 */
export function instanceOfSubscriptionControllerRunJob200Response(value: object): value is SubscriptionControllerRunJob200Response {
    return true;
}

export function SubscriptionControllerRunJob200ResponseFromJSON(json: any): SubscriptionControllerRunJob200Response {
    return SubscriptionControllerRunJob200ResponseFromJSONTyped(json, false);
}

export function SubscriptionControllerRunJob200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionControllerRunJob200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'result': json['result'] == null ? undefined : json['result'],
    };
}

export function SubscriptionControllerRunJob200ResponseToJSON(json: any): SubscriptionControllerRunJob200Response {
    return SubscriptionControllerRunJob200ResponseToJSONTyped(json, false);
}

export function SubscriptionControllerRunJob200ResponseToJSONTyped(value?: SubscriptionControllerRunJob200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': value['result'],
    };
}

